module.exports = __webpack_public_path__ + "img/phyto-rouge-photo-ambiance-13@2x.5d481412.jpg";